import { Component, EventBus } from '../core/smpl-components'
import { Accordion } from '../modules/accordion'
import { MqlMatchMedia } from '../utils/mql-match-media'
import debounce from 'lodash/debounce'

// -------------------------------------------------------------------------- //
export default class extends Component {
	prepare() {}
	mount() {
		this.initAccordion()
	}
	unmount() {}
	//
	initAccordion() {
		this.debouncedOnChange = debounce(() => {
			EventBus.emit('page:resize')
		}, 500)

		this.accordion = new Accordion(this.element, {
			onChanged: this.debouncedOnChange,
		})
	}
	destroyAccordion() {
		if (this.accordion) {
			this.accordion.destroy()
		}
	}
}
